import React from "react";
import { motion } from "framer-motion";
import { Bot, Monitor, BookOpen, ArrowRight } from "lucide-react";
import "./InnovationSection.scss";

import aiImage    from "../assets/Our-projects/dehradun c meet training .webp";
import smartImage from "../assets/innovation/smart-classes.webp";
import techImage  from "../assets/nextgen/ng-lab-4.jpeg";

const CARDS = [
  {
    image:   aiImage,
    icon:    Bot,
    iconBg:  "#ede9fe",
    iconColor: "#7c3aed",
    badge:   { bg: "#ede9fe", color: "#7c3aed" },
    title:   "AI for Teachers",
    desc:    "Our AI-powered tools assist teachers in creating personalized lesson plans, grading assignments efficiently, and providing real-time feedback to students.",
    href:    "/services#ai",
  },
  {
    image:   smartImage,
    icon:    Monitor,
    iconBg:  "#eff6ff",
    iconColor: "#2563eb",
    badge:   { bg: "#eff6ff", color: "#2563eb" },
    title:   "Smart Classes",
    desc:    "Equipped with the latest technology, our smart classrooms facilitate interactive and immersive learning experiences that inspire curiosity and creativity.",
    href:    "/services#smart",
  },
  {
    image:   techImage,
    icon:    BookOpen,
    iconBg:  "#f0fdf4",
    iconColor: "#16a34a",
    badge:   { bg: "#f0fdf4", color: "#16a34a" },
    title:   "Curriculum on Emerging Tech",
    desc:    "Hands-on labs in AI, Robotics, Coding, and tinkering give students real-world skills and 10+ emerging-tech courses that prepare them for the future workforce.",
    href:    "/services#curriculum",
  },
];

const anim = (d = 0) => ({
  initial:     { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport:    { once: true, margin: "-60px" },
  transition:  { duration: 0.4, delay: d, ease: "easeOut" },
});

export default function InnovationSection() {
  return (
    <section className="inn-wrap">
      <div className="inn-inner">

        {/* heading */}
        <motion.div className="inn__top" {...anim(0)}>
          <div className="inn__chip">✦ INNOVATION AT COGRAD</div>
          <h2 className="inn__h2">
            How Are We Innovating<br />
            With <span>Technology?</span>
          </h2>
          <div className="inn__rule" />
          <p className="inn__sub">
            We leverage AI and emerging technologies to create<br />
            smarter classrooms and future-ready learners.
          </p>
        </motion.div>

        {/* 3 cards */}
        <div className="inn__grid">
          {CARDS.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div key={i} className="inn__card" {...anim(0.1 + i * 0.1)}>

                {/* image + floating badge */}
                <div className="inn__img-wrap">
                  <img src={card.image} alt={card.title} className="inn__img" />
                  <span className="inn__badge"
                    style={{ background: card.badge.bg, color: card.badge.color }}>
                    <Icon size={18} />
                  </span>
                </div>

                {/* content */}
                <div className="inn__body">
                  <div className="inn__title-row">
                    <span className="inn__ico"
                      style={{ background: card.iconBg, color: card.iconColor }}>
                      <Icon size={18} />
                    </span>
                    <h3 className="inn__title">{card.title}</h3>
                  </div>
                  <p className="inn__desc">{card.desc}</p>
                  <a href={card.href} className="inn__link">
                    Learn more <ArrowRight size={14} />
                  </a>
                </div>

              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
